export const email = 'email';
export const webpage = 'webpage';
export const form = 'form';
export default {
  email,
  webpage,
  form
};